/** セミナー詳細 タイプ 1:勉強会 */
export const SEMINAR_INFORMATION_TYPE_STUDY_GROUP = {
    label: '勉強会',
    value: 1,
};
/** セミナー詳細 タイプ 2:ワークショップ */
export const SEMINAR_INFORMATION_TYPE_WORKSHOP = {
    label: 'ワークショップ',
    value: 2,
};
/** セミナー詳細 タイプ 3:対談 */
export const SEMINAR_INFORMATION_TYPE_DIALOGUE = {
    label: '対談',
    value: 3,
};
/** セミナー詳細 タイプ 4:動画 */
export const SEMINAR_INFORMATION_TYPE_MOVIE = {
    label: '動画',
    value: 4,
};
/**
 * セミナー詳細 タイプ
 */
export const SEMINAR_INFORMATION_TYPES = [
    SEMINAR_INFORMATION_TYPE_STUDY_GROUP,
    SEMINAR_INFORMATION_TYPE_WORKSHOP,
    SEMINAR_INFORMATION_TYPE_DIALOGUE,
    SEMINAR_INFORMATION_TYPE_MOVIE,
];
